import { reactive, computed } from 'vue'
import type { SiteConfig } from '@/types'
import { loadFromStorage, saveToStorage } from '@/utils/storage'
import { STORAGE_KEYS } from '@/constants/keys'
import { verifyHaloSite } from '@/utils/validation'
import { fetchSiteInfo } from '@/services/siteInfo'

const ENV_DEFAULT: SiteConfig = {
  url: import.meta.env.VITE_SITE_URL || '',
  creationTime: import.meta.env.VITE_SITE_CREATION_TIME || '',
  title: '',
  favicon: ''
}

const siteConfig = reactive<SiteConfig>(loadFromStorage(STORAGE_KEYS.SITE_CONFIG, ENV_DEFAULT))

const isConfigured = computed(() => !!siteConfig.url)

async function autoFetchSiteInfo() {
  if (!siteConfig.url) return
  if (siteConfig.title) return

  try {
    const verifyResult = await verifyHaloSite(siteConfig.url)
    const siteInfo = fetchSiteInfo(siteConfig.url)
    const title = verifyResult.title || siteInfo?.name || new URL(siteConfig.url).hostname
    const favicon = verifyResult.favicon

    if (title) siteConfig.title = title
    if (favicon) siteConfig.favicon = favicon

    saveToStorage(STORAGE_KEYS.SITE_CONFIG, { ...siteConfig })
  } catch {
    console.error('自动获取站点信息失败')
  }
}

autoFetchSiteInfo()

export function useSiteConfig() {
  function updateSiteConfig(config: Partial<SiteConfig>) {
    if (config.url !== undefined) siteConfig.url = config.url
    if (config.creationTime !== undefined) siteConfig.creationTime = config.creationTime
    if (config.title !== undefined) siteConfig.title = config.title
    if (config.favicon !== undefined) siteConfig.favicon = config.favicon
    saveToStorage(STORAGE_KEYS.SITE_CONFIG, { ...siteConfig })
  }

  return {
    siteConfig,
    isConfigured,
    updateSiteConfig
  }
}
